import { normalizedUuidSchema } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { useParams } from 'react-router';
import { ProductEditAreaWorkspace } from '@/widgets/product-edit-area';

export const ProductEditAreaPage = (): ReactElement => {
  const { productId } = useParams<{ productId: string }>();
  const parsed = normalizedUuidSchema.safeParse(productId);
  return parsed.success ? (
    <ProductEditAreaWorkspace key={parsed.data} productId={parsed.data} />
  ) : (
    <p role="alert">올바른 상품 주소가 아닙니다.</p>
  );
};
